export default __webpack_public_path__ + "static/cafe_36079-a069b04af61323298d9f99be4678fc7c.png";